import React, { useEffect, useState } from 'react';
import { FaTimes, FaCommentDots } from 'react-icons/fa';
import { useAuth } from '../hooks/useAuth';
import './WelcomeBanner.css';

const storageKey = (userId) => `pop1_welcome_dismissed_${userId || 'anon'}`;

const WelcomeBanner = () => {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    try {
      const dismissed = localStorage.getItem(storageKey(user.id)) === '1';
      setVisible(!dismissed);
    } catch (e) {
      setVisible(true);
    }
  }, [user?.id]);

  const dismiss = () => {
    if (user?.id) {
      try { localStorage.setItem(storageKey(user.id), '1'); } catch (e) { /* ignore */ }
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="welcome-banner" role="status">
      <button
        type="button"
        className="welcome-banner-close"
        onClick={dismiss}
        aria-label="Dismiss welcome message"
      >
        <FaTimes />
      </button>
      <h3 className="welcome-banner-title">
        <span role="img" aria-label="Wave">👋</span> Welcome to Pop1 <span className="welcome-banner-badge">beta</span>
      </h3>
      <p className="welcome-banner-lede">
        Glad to have you — you&apos;re one of the first collectors in. A couple
        of quick things while we&apos;re still in beta:
      </p>
      <ul className="welcome-banner-list">
        <li>
          <strong>Found a bug or got an idea?</strong> Tap the{' '}
          <span className="welcome-banner-pill-ref" aria-label="Beta Feedback">
            <FaCommentDots aria-hidden="true" />
            <span className="welcome-banner-pill-ref-text"> Beta · Feedback</span>
          </span>{' '}
          button in the bottom-right corner — it goes straight to us.
        </li>
        <li>
          <strong>Our emails sometimes land in spam right now.</strong> If you
          spot a Pop1 email there, please mark it &ldquo;Not Spam&rdquo; so
          future updates reach your inbox.
        </li>
      </ul>
      <div className="welcome-banner-actions">
        <button type="button" className="welcome-banner-cta" onClick={dismiss}>
          Got it — let&apos;s go
        </button>
      </div>
    </div>
  );
};

export default WelcomeBanner;
